import { useEffect } from "react";
import { useLocalStorage } from "react-use";
import { useGameState } from "app/game/useGame";

interface VisitCounterProps {
  storeKey?: string;
  maxVisits?: number;
}

export default function useVisitCounter({
  storeKey = "VISITED_GAME_IDS",
  maxVisits = 4,
}: VisitCounterProps) {
  const { id } = useGameState();
  const [visitIds, setVisits, remove] = useLocalStorage<string[]>(storeKey, []);
  const visitCount = visitIds?.length || 0;

  useEffect(() => {
    if (!id) {
      return;
    }

    setVisits((gameIds = []) =>
      gameIds.length >= maxVisits ? gameIds : [...new Set([...gameIds, id])],
    );
  }, [id, setVisits, maxVisits]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("reset")) {
      remove();
    }
  }, [remove]);

  return {
    visitIds: visitIds || [],
    visitCount,
    reachedLimit: visitCount >= maxVisits,
  };
}
